/**
 * PC版・スマホ版の切替のアイコン（#120、docs/44 §8.4・docs/10 §9.14）：40×32px・角丸 6px・枠 #C8C5BC・白地、中は 20px の線のアイコン（藍）。
 *   スマホ版のときはパソコン（lucide の monitor）で「PC版で表示」、PC版のときはスマホ（lucide の smartphone）で「スマホ版で表示」。
 *   aria-label と title に同じ文。押せる範囲は ::before で上下に広げて 44px。
 *   出す条件と押したときの動きは #115 のまま（lib/view.ts：PC版は短い辺 1099px 以下で指で操作できる端末か、PC版を選んだ端末だけ。押すと Cookie を書いて開き直す）。
 *   置き場所は下の帯の「文字の大きさ［小｜中｜大］」のすぐ右と、アカウントメニューの「文字の大きさ」の行の右（menu＝role="menuitem"）
 */
import { VIEW_MSG } from "@genbaryoku/contract";
import { canOfferPhone, currentView, switchView } from "../lib/view.js";
import { GroupNavRow, RowIcon } from "./GroupList.jsx";

export function ViewSwitch({ menu = false }: { menu?: boolean }) {
  const phone = currentView() === "phone";
  if (!phone && !canOfferPhone()) return null;
  const label = phone ? VIEW_MSG.toPc : VIEW_MSG.toPhone;
  const testId = `${menu ? "menu-" : ""}${phone ? "view-to-pc" : "view-to-phone"}`;
  return (
    <button type="button" className="vswitch" role={menu ? "menuitem" : undefined} aria-label={label} title={label} onClick={() => switchView(phone ? "pc" : "phone")} data-testid={testId}>
      {phone ? (
        // lucide: monitor
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <rect width="20" height="14" x="2" y="3" rx="2" />
          <path d="M8 21h8M12 17v4" />
        </svg>
      ) : (
        // lucide: smartphone
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <rect width="14" height="20" x="5" y="2" rx="2" ry="2" />
          <path d="M12 18h.01" />
        </svg>
      )}
    </button>
  );
}

/**
 * PC版・スマホ版の切替の行（#152、docs/61 ★i）：アカウントのメニューと個人設定の「表示」のまとまりの1行（行の絵＋「PC版で表示」／「スマホ版で表示」）。
 *   出す条件と押したときの動きは上の ViewSwitch と同じ（lib/view.ts）。menu＝メニューの中（role="menuitem"）
 */
export function ViewSwitchRow({ menu = false }: { menu?: boolean }) {
  const phone = currentView() === "phone";
  if (!phone && !canOfferPhone()) return null;
  const label = phone ? VIEW_MSG.toPc : VIEW_MSG.toPhone;
  const testId = `${menu ? "menu-" : ""}${phone ? "view-to-pc" : "view-to-phone"}`;
  return <GroupNavRow menu={menu} icon={<RowIcon k={phone ? "monitor" : "phone"} />} title={label} onClick={() => switchView(phone ? "pc" : "phone")} buttonTestId={testId} />;
}
